/*! facett renewal — FAQ（アコーディオン排他開閉）
 * Hero 非干渉: data-facett-faq のみ
 */
(function () {
  function bindExclusive(root) {
    if (!root || root.dataset.facettFaqBound === '1') return;
    root.dataset.facettFaqBound = '1';

    root.addEventListener(
      'toggle',
      function (event) {
        var target = event.target;
        if (!target || target.tagName !== 'DETAILS' || !target.open) return;
        root.querySelectorAll('details.facett-faq__item[open]').forEach(function (el) {
          if (el !== target) el.open = false;
        });
      },
      true
    );
  }

  function boot() {
    document.querySelectorAll('[data-facett-faq]').forEach(bindExclusive);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-faq]');
    if (root) {
      root.dataset.facettFaqBound = '';
      bindExclusive(root);
    }
  });
})();
